import React from 'react'
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from "react-router-dom";
import {withStyles} from '@material-ui/core/styles';

const useStyles = theme => ({
  root: {
    width: '100%',
    maxWidth: 270,        
  },
  inline: {
    display: 'inline',
  },
  link:{
    textDecoration: 'none',
    color: 'rgba(0,0,0,.6)',
    "&:hover": {
      color:'rgba(0,0,0,.8)',
    },
  },
});


class MenuDataset extends React.Component {

  getLink = (info) => {
    if(info.dashboard){
      return "/pivot/dashboard/" + info.id
    } else {
      return "/pivot/module/" + info.id
    }
  }

  render(){

   const { classes, 
            info,
            anchor            
           } = this.props;
  
    return (
      <Link to={this.getLink(info)} className={classes.link} >
        <ListItem button onClick={anchor}  >              
          <ListItemText primary={info.description} />          
        </ListItem>
      </Link>  
    )
  }

}

//onClick={handlerAnchor}
export default withStyles(useStyles)(MenuDataset)